export enum EClientNotificationsEventTypes {
  onCentralNotification = 'onCentralNotification',
  onCentralNotificationContract = 'onCentralNotificationContract',
  onGympassCheckinNotification = 'onGympassCheckinNotification',
  onTotalpassCheckinNotification = 'onTotalpassCheckinNotification',
  onInvoicesZipCreatedNotification = 'onInvoicesZipCreatedNotification',
  onAccessRealTimeOccupancyNotification = 'onAccessRealTimeOccupancyNotification',
  onCompletedConsumptionNotification = 'onCompletedConsumptionNotification',
  onUserPhotoUploadedNotification = 'onUserPhotoUploadedNotification',
}